// Invitations to join the control panel team: an admin invites by email
// instead of typing a password for someone else; the invited person follows
// the emailed link and sets their own password.
import { api, setToken } from "./client";

export async function getInvites() {
  const { invites } = await api.get("/invites", { auth: true });
  return invites;
}

export async function createInvite({ name, email, role }) {
  const { id } = await api.post(
    "/invites",
    { name: String(name || "").trim(), email: String(email || "").trim(), role: role || "member" },
    { auth: true }
  );
  return id;
}

export async function deleteInvite(id) {
  await api.del(`/invites/${id}`, { auth: true });
}

// Public: look up an invite by its token — the invited person isn't signed in yet.
export async function getInvite(token) {
  return api.get(`/invites/${encodeURIComponent(token)}`);
}

// Public: accept the invite, set a password, and sign in.
export async function acceptInvite(token, { password, name }) {
  const { token: jwt, user } = await api.post(`/invites/${encodeURIComponent(token)}`, { password, name });
  setToken(jwt);
  window.dispatchEvent(new CustomEvent("vo:auth-change"));
  return user;
}
